import $ from 'jquery';

$(() => {
    $('#mobile-menu-open').on('click', function(event) {
        event.preventDefault();
        $('body').addClass('mobile-menu-open');
    });

    $('#mobile-menu-close').on('click', function(event) {
        event.preventDefault();
        $('body').removeClass('mobile-menu-open');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/components/MobileMenu.ts